<template>
    <v-card>
        <slot>
            <v-card-title>
                {{ title }}
                <v-spacer></v-spacer>
                <v-text-field
                    v-model.lazy="search"
                    append-icon="mdi-magnify"
                    label="Cautare..."
                    single-line
                    hide-details
                ></v-text-field>
                <v-dialog
                    v-model="dialog"
                    max-width="50vw"
                >
                    <template v-slot:activator="{ on, attrs }">
                        <v-btn
                            color="primary"
                            dark
                            class="ml-2"
                            v-bind="attrs"
                            v-on="on"
                        >
                            Adaugare
                        </v-btn>
                    </template>
                    <v-card>
                        <v-card-title>
                            <span class="headline">{{ formTitle }}</span>
                        </v-card-title>

                        <v-card-text>
                            <v-container>
                                <v-row>
                                    <v-col cols="12">
                                        <v-select
                                            :items="accounts"
                                            item-text="name"
                                            item-value="id"
                                            v-model="form.payer"
                                            label="Cont sursa"
                                            data-vv-as="Cont sursa"
                                            v-validate="'required'"
                                            :error-messages="errorMessages(`payer`)"
                                            :class="{ 'error--text': hasErrors(`payer`) }"
                                            class="primary--text"
                                            :name="`payer`"
                                            :data-vv-name="`payer`"
                                            return-object
                                        ></v-select>
                                        <v-select
                                            :items="employees"
                                            item-text="name"
                                            item-value="id"
                                            v-model="form.subject"
                                            label="Utilizator"
                                            data-vv-as="Utilizator"
                                            v-validate="'required'"
                                            :error-messages="errorMessages(`subject`)"
                                            :class="{ 'error--text': hasErrors(`subject`) }"
                                            class="primary--text"
                                            :name="`subject`"
                                            :data-vv-name="`subject`"
                                            return-object
                                        ></v-select>
                                        <v-text-field
                                            v-model="form.amount"
                                            label="Valoare"
                                            data-vv-as="Valoare"
                                            v-validate="'required'"
                                            :error-messages="errorMessages(`amount`)"
                                            :class="{ 'error--text': hasErrors(`amount`) }"
                                            class="primary--text"
                                            :name="`amount`"
                                            :data-vv-name="`amount`"
                                            type="number"
                                        ></v-text-field>
                                        <v-textarea
                                            v-model="form.remarks"
                                            label="Observatii"
                                            data-vv-as="Observatii"
                                            :error-messages="errorMessages('remarks')"
                                            :class="{ 'error--text': hasErrors('remarks') }"
                                            class="primary--text"
                                            name="remarks"
                                            data-vv-name="remarks"
                                        ></v-textarea>
                                    </v-col>
                                </v-row>
                            </v-container>
                        </v-card-text>

                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn
                                color="blue darken-1"
                                text
                                @click="close"
                            >
                                Renuntare
                            </v-btn>
                            <v-btn
                                :disabled="!_.isNil(form.id)"
                                color="blue darken-1"
                                text
                                @click="save"
                            >
                                Salveaza
                            </v-btn>
                        </v-card-actions>
                    </v-card>
                </v-dialog>
                <v-dialog v-model="dialogDelete" max-width="500px">
                    <v-card>
                        <v-card-title class="headline">Sunteti sigur ca doriti stergerea intrarii?</v-card-title>
                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn color="red darken-1" text @click="closeDelete">Anulare</v-btn>
                            <v-btn color="blue darken-1" text @click="deleteItemConfirm">Confirmare</v-btn>
                            <v-spacer></v-spacer>
                        </v-card-actions>
                    </v-card>
                </v-dialog>
            </v-card-title>
        </slot>
        <v-data-table
            :headers="headers"
            :items="items"
            :options.sync="options"
            :server-items-length="meta.pagination.total"
            class="elevation-1"
        >
            <template v-slot:item.payer_id="{ item }">
                {{ _.get(Static.accounts.find(account => account.id === item.payer_id), 'name', 'Nedefinit') }}
            </template>
            <template v-slot:item.amount="{ item }">
                {{ item.amount | price }}
            </template>
            <template v-slot:item.subject_id="{ item }">
                {{ _.get(employees.find(employee => employee.id === item.subject_id), 'name', 'Nedefinit') }}
            </template>
            <template v-slot:item.created_by="{ item }">
                {{ item.created_by.name }}<br/>
                {{ item.updated_by.name }}
            </template>
            <template v-slot:item.created_at="{ item }">
                {{ new Date(item.created_at) | datetime }}
            </template>
            <template v-slot:item.actions="{ item }">
                <v-icon
                    small
                    class="mr-2"
                    @click="editItem(item)"
                >
                    mdi-pencil
                </v-icon>
            </template>
            <template v-slot:no-data>
                <p class="my-2">Nu am gasit nici un rezultat.</p>
                <v-btn
                    class="my-2"
                    color="primary"
                    @click="reset"
                >
                    Eliminare filtre
                </v-btn>
            </template>
        </v-data-table>
    </v-card>
</template>

<script>
    import SmartTable from "Components/SmartTable";
    import {Form} from "vform";
    export default {
        extends: SmartTable,
        data: () => ({
            title: 'Plati',
            dialog: false,
            dialogDelete: false,
            headers: [
                { text: 'Cont sursa', value: 'payer_id' },
                { text: 'Valoare', value: 'amount' },
                { text: 'Destinatie', value: 'subject_id' },
                { text: 'Data', value: 'created_at' },
                { text: 'Adaugat/Creat de', value: 'created_by' },
                { text: 'Actiuni', value: 'actions', sortable: false },
            ],
            options: {
                sortBy: ['id'],
                sortDesc: [true]
            },
            items: [],
            editedIndex: -1,
            users: []
        }),

        computed: {
            formTitle () {
                return this.editedIndex === -1 ? 'Adaugare' : 'Modificare'
            },
            accounts() {
                return this.Static.accounts.map((account) => {
                    return {
                        id: account.id,
                        name: account.name,
                        type: 'App\\Models\\Account'
                    }
                })
            },
            employees() {
                return this.users.map((user) => {
                    return {
                        id: user.id,
                        name: user.name,
                        type: 'App\\Models\\User'
                    }
                })
            }
        },

        async created () {
            await this.loadEmployees()
            await this.initialize()
        },

        methods: {
            async initialize () {
                let { data, meta } = await this.$db.Payment
                    .where('method', 'output')
                    .include('createdBy', 'updatedBy')
                    .orderBy(this.orderBy)
                    .page(this.options.page)
                    .limit(this.options.itemsPerPage)
                    .params({
                        query: this.search
                    })
                    .get()
                this.items = data.map((payment) => {
                    payment.payer = this.Static.accounts.find(account => account.id === payment.payer_id)
                    payment.subject = this.Static.accounts.find(account => account.id === payment.subject_id)
                    return payment
                })
                this.meta = meta
            },
            async loadEmployees () {
                let { data, meta } = await this.$db.Employee
                    .where('active', true)
                    .page(1)
                    .limit(500)
                    .get()
                this.users = data.sort(function(a, b) {
                    var nameA = a.name.toUpperCase();
                    var nameB = b.name.toUpperCase();
                    return (nameA < nameB) ? -1 : (nameA > nameB) ? 1 : 0;
                });
            },
            deleteItem (item) {
                this.editedIndex = this.items.indexOf(item)
                this.editedItem = Object.assign({}, item)
                this.dialogDelete = true
            },

            async deleteItemConfirm () {
                let item = this.items[this.editedIndex]
                if(item instanceof this.$db.Payment) {
                    await item.delete()
                } else {
                    console.warn('Here comes the headache...')
                }
                this.dialogDelete = false
                await this.initialize()
            },

            close () {
                this.dialog = false
                this.$nextTick(() => {
                    this.form = new Form(Object.assign({}, this.defaultItem))
                    this.editedIndex = -1
                })
            },

            closeDelete () {
                this.dialogDelete = false
                this.$nextTick(() => {
                    this.editedItem = Object.assign({}, this.defaultItem)
                    this.editedIndex = -1
                })
            },
            save () {
                let self = this;
                this.$validator.validateAll().then(result => {
                    if (result) {
                        // eslint-disable-next-line
                        self.createOrUpdate();
                    } else {
                        this.showError()
                    }
                });
            },
            async createOrUpdate() {
                let self = this;

                new this.$db.Payment(self.form)
                    .save()
                    .then(response => {
                        self.$validator.reset();
                        this.showSuccess();
                    }).then(() => {
                    this.initialize()
                    this.close()
                })
                .catch(errors => {
                    self.form.errors.set(this.form.extractErrors(errors.response))
                    this.showError()
                })
            },
        },
    };
</script>
